import React from "react";

export function Earnings(){
    return(
        <>
            <div>Earnings </div>
        </>
    )
}